import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import AddressSearchInput from '../components/AddressSearchInput';
import landingImage from '../assets/landing-hero.jpg';
import '../App.css';

const Home = () => {
    const navigate = useNavigate();

    const handleSelect = (sel) => {
        if (sel.type === 'city') {
            navigate(`/search?city=${encodeURIComponent(sel.city)}&state=${encodeURIComponent(sel.state)}`);
        } else if (sel.type === 'zip') {
            navigate(`/search?zip_code=${encodeURIComponent(sel.zip_code)}`);
        }
    };

    return (
        <Layout isTransparent>
            <div className="hero-section">
                <div className="hero-content">
                    <h1>Find Deals in seconds</h1>
                    <p>AI-powered deal analysis for smarter real estate investments</p>
                    <div className="hero-search-form">
                        <AddressSearchInput
                            placeholder="Enter an address, city, or ZIP code"
                            variant="hero"
                            onSelect={handleSelect}
                        />
                    </div>
                </div>
                <div className="hero-overlay"></div>
                <img
                    src={landingImage}
                    alt="Modern Home"
                    className="hero-bg-image"
                />
            </div>
        </Layout>
    );
};

export default Home;
